import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { IWidget } from 'core-components/sitebuilder/models/IWidget'
import { selectWidgets } from 'core-components/sitebuilder/store/selectors/selectWidgets'

export const useWidget = (widgetId: string) => {
  const widgets = useSelector(selectWidgets)

  return useMemo(() => {
    return widgets.find((el) => el.i === widgetId) || ({} as IWidget)
  }, [widgets, widgetId])
}
